/**
 * Official OpenSesame pinwheel logo mark.
 * Source: opensesame.art/design_specs/logos/opensesame-pinwheel.svg
 * (matches apps/ecp/src/components/opensesame-logo.tsx, with fill switched to
 * currentColor so the mark inherits its color from the surrounding element.)
 */
export function Pinwheel({
  className,
  size = 48
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="78.65 0 224 224"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="m1728.25,2492.32c-80.1-80.1-130.4-184.3-156.3-283-32.9-119.1-66.4-288.2-185.9-407.7-119.69-119.6-288.69-153.1-407.89-186.01-98.695-25.9-202.894-76.3-282.992-156.3-135.898-135.9-138.398-333.8-17.902-454.3 120.5-120.498 318.297-117.901 454.294 17.9 79.7 79.7 130 183.5 156 281.8 32.89 119.2 66.29 289 186.19 408.9 119.9 119.91 289.7 153.21 408.89 186.21 98.3 26 202.1 76.3 281.8 156 135.9 135.9 138.4 333.8 17.9 454.3-120.3 120.7-318.2 118.2-454.09-17.8zm-454.69-578.3c69.99 70 45.69 390.6-142 578.3-135.997 136-333.896 138.5-454.392 18-120.5-120.5-117.898-318.3 17.898-454.3 187.797-187.7 508.494-212 578.494-142zm454.69-891.11c135.89-135.898 333.79-138.398 454.29-17.9 120.5 120.5 117.9 318.3-17.9 454.3-187.7 187.71-508.39 212.01-578.29 142.01-70.1-70.01-45.8-390.71 141.9-578.41"
        fill="currentColor"
        fillRule="evenodd"
        transform="matrix(.13333 0 0 -.13333 0 346.36)"
      />
    </svg>
  );
}
